
import { formatDate, formatPrice } from "@/app/infrastructures/misc/Utils";
import { Options, prop, Vue } from "vue-class-component";
import OverlayPanel from "primevue/overlaypanel";

class Props {
  summary = prop<any>({
    required: true
  });
}

@Options({
  components: {
    OverlayPanel
  }
})

export default class DetailItems extends Vue.with(Props) {
  private isCollapsed = false;

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  formatDateTime(date: any): string {
    return formatDate(date);
  }

  formatPriceNumber(price: number) {
    return price? formatPrice(price) : "-";
  }

  formatWeightNumber(weight: number) {
    const fixed = weight.toFixed(2);
    const [integerPart, decimalPart] = fixed.split('.');
    return decimalPart === '00' ? integerPart : `${integerPart},${decimalPart}`;
  }

  toggleTooltip(event: any) {
    const refs: any = this.$refs;
    refs["commodityName"].toggle(event);
  }
}
